<div class="title p-2 viewDocumentSectionTitle">
    <div class="row">
        <div class="col-md-6">
            <h1 class="mx-2 mt-3 mb-0">
                <span><strong>Info beneficiar
                        {{ beneficiar?.id }} /
                        {{ beneficiar?.created_at | date: "dd.MM.yyyy" : "ro" }}</strong></span>
                <span class="text-secondary mx-2">#{{ beneficiar?.id }}</span>
                <button type="button" class="btn btn-sm btn-primary me-2" (click)="getBeneficiarInfo()">
                    <i class="fa-solid fa-arrows-rotate"></i>
                    <span class="ms-2">Reîncarcă informații</span>
                </button>
                <button type="button" class="btn btn-sm btn-danger me-2" title="Ștergere" (click)="deleteBeneficiar()">
                    <i class="fa-solid fa-trash"></i>
                    <span class="ms-2">Ștergere</span>
                </button>
                <button type="button" class="btn btn-sm btn-info me-2" title="Descărcare" (click)="downloadFisa()">
                    <i class="fa-solid fa-download"></i>
                    <span class="ms-2">Descărcare</span>
                </button>
            </h1>
        </div>
        <div class="col-md-6 d-flex justify-content-end align-items-center">
            <div class="px-2 d-flex flex-column border-end border-dark hide-content">
                <span class="fw-bold">{{ activeAccess?.denumire_directie }}</span>
                <span>{{ activeAccess?.denumire_compartiment || 'n/a' }}</span>
            </div>
            <div class="px-2 d-flex flex-column">
                <span class="fw-bold">{{ user?.name || 'n/a' }}</span>
                <span>{{ activeFunction?.functie_name || 'n/a' }}</span>
            </div>
            <button type="button" class="ps-2 action-btn" (click)="closeDialog()">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>

<div class="row p-3 responsive-content viewDocumentContentSection">
    <div class="col-lg-8">
        <mat-card>
            <app-subsemnat *ngIf="beneficiar" [beneficiar]="beneficiar" (beneficiarChanged)="getBeneficiarInfo()"
                (isLoading)="onIsLoadingChange($event)"></app-subsemnat>

            <app-documente *ngIf="beneficiar" [beneficiar]="beneficiar"
                (beneficiarChanged)="getBeneficiarInfo()"></app-documente>

            <app-mesagerie *ngIf="beneficiar" [beneficiar]="beneficiar"
                (beneficiarChanged)="getBeneficiarInfo()"></app-mesagerie>

            <app-istoric *ngIf="beneficiar && beneficiar.history && user" [beneficiar]="beneficiar"
                [history]="beneficiar.history" [user]="user" (isLoading)="onIsLoadingChange($event)"></app-istoric>
        </mat-card>
    </div>

    <div class="col-lg-4">
        <mat-card>
            <!-- ── Contracte ─────────────────────────────────────────────── -->
            <div class="g-0" *ngIf="beneficiar?.contracts?.length">
                <div class="box-wrapper box-info">
                    <div class="box-content-header"
                        style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
                        <div class="row p-1">
                            <div class="col">
                                <div class="d-flex flex-row justify-content-between align-items-center">
                                    <mat-card-title style="color: white;">
                                        <i class="fa-solid fa-file-contract"></i>
                                        <span>Contracte ({{ beneficiar?.contracts?.length }})</span>
                                    </mat-card-title>
                                    <div class="d-flex align-items-center gap-2">
                                        <!-- Butonul Vezi apare doar când e un singur contract -->
                                        <button *ngIf="beneficiar!.contracts.length === 1" type="button"
                                            class="btn btn-sm btn-info" title="Vizualizare contract"
                                            (click)="openContractDetails(beneficiar!.contracts[0].id)">
                                            <i class="fa-solid fa-eye"></i>
                                            <span class="ms-1">Vezi</span>
                                        </button>
                                        <!-- Butonul expand apare doar când sunt mai multe contracte -->
                                        <button *ngIf="beneficiar!.contracts.length > 1" type="button"
                                            class="btn btn-sm"
                                            style="background-color: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.4);"
                                            (click)="toggleAllContracts()">
                                            <i class="fa-solid"
                                                [ngClass]="allContractsExpanded ? 'fa-angles-up' : 'fa-angles-down'"></i>
                                            <span class="ms-1">{{ allContractsExpanded ? 'Strânge tot' : 'Extinde tot'
                                                }}</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="box-content-body p-0">
                        <ng-container *ngFor="let contract of beneficiar?.contracts; let i = index">

                            <!-- Header cu toggle + Vezi: doar când sunt mai multe contracte -->
                            <ng-container *ngIf="beneficiar!.contracts.length > 1">
                                <div class="d-flex justify-content-between align-items-center px-3 py-2"
                                    style="cursor: pointer; border-bottom: 1px solid #e0e0e0;"
                                    [style.background-color]="expandedContracts[i] ? '#f3f0fa' : 'white'"
                                    (click)="toggleContract(i)">
                                    <div class="d-flex align-items-center flex-wrap gap-2">
                                        <span class="fw-bold">
                                            <i class="fa-solid fa-hashtag me-1 text-primary"></i>
                                            Nr. {{ contract.nr_contract || 'N/A' }}
                                        </span>
                                        <span class="text-muted small">
                                            <i class="fa-solid fa-calendar-day me-1"></i>
                                            {{ formatDate(contract.data_contract) }}
                                        </span>
                                        <span class="badge" [ngClass]="contract.active ? 'bg-success' : 'bg-secondary'">
                                            {{ contract.active ? 'Activ' : 'Inactiv' }}
                                        </span>
                                    </div>
                                    <div class="d-flex align-items-center gap-2" (click)="$event.stopPropagation()">
                                        <button type="button" class="btn btn-sm btn-info" title="Vizualizare contract"
                                            (click)="openContractDetails(contract.id)">
                                            <i class="fa-solid fa-eye"></i>
                                            <span class="ms-1">Vezi</span>
                                        </button>
                                        <i class="fa-solid text-secondary"
                                            [ngClass]="expandedContracts[i] ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                                    </div>
                                </div>
                            </ng-container>

                            <!-- Detalii: mereu vizibil dacă e unul singur, altfel controlat de expand -->
                            <div *ngIf="beneficiar!.contracts.length === 1 || expandedContracts[i]"
                                style="border-bottom: 2px solid #764ba2;">
                                <table class="table table-condensed table-wrapper-box mb-0">
                                    <tbody>
                                        <tr>
                                            <td width="45%" class="text-center">
                                                <strong><i class="fa-solid fa-hashtag me-1"></i>Nr. Contract</strong>
                                            </td>
                                            <td>{{ contract.nr_contract || 'N/A' }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-calendar-day me-1"></i>Dată
                                                    contract</strong>
                                            </td>
                                            <td>{{ formatDate(contract.data_contract) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-calendar-plus me-1"></i>Dată
                                                    început</strong>
                                            </td>
                                            <td>{{ formatDate(contract.date_from_contract) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-calendar-xmark me-1"></i>Dată
                                                    sfârșit</strong>
                                            </td>
                                            <td>{{ formatDate(contract.date_end_contract) }}</td>
                                        </tr>
                                        <tr>
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-user-pen me-1"></i>Creat de</strong>
                                            </td>
                                            <td>{{ contract.created_by_user_name || 'N/A' }}</td>
                                        </tr>
                                        <tr *ngIf="contract.subcontracts.length">
                                            <td class="text-center">
                                                <strong><i class="fa-solid fa-layer-group me-1"></i>Programări
                                                    Contractuale</strong>
                                            </td>
                                            <td>{{ contract.subcontracts.length }}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                        </ng-container>
                    </div>
                </div>
            </div>

            <app-documente-indoc *ngIf="beneficiar" [beneficiar]="beneficiar"
                (isLoading)="onIsLoadingChange($event)"></app-documente-indoc>
        </mat-card>
    </div>
</div>

<div class="section-spinner position-fixed" *ngIf="isLoading">
    <div class="spinner position-absolute top-50 start-50 translate-middle">
        <img src="assets/icons/logo-ps4-icon.svg" height="50%" width="50%" alt="PS4" />
        <mat-spinner></mat-spinner>
        <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
    </div>
</div>